
export enum PermissionCodes {
    ViewAdministration = 1,
    ViewUser = 2,
    AddUser = 3,
    UpdateUser = 4,
    DeleteUser = 5,
    ViewRole = 6,
    AddRole = 7,
    UpdateRole = 8,
    DeleteRole = 9,
    ViewInspectionDate = 10,
    AddInspectionDate = 11,
    UpdateInspectionDate = 12,
    DeleteInspectionDate = 13,
    ViewDashboardImage = 14,
    AddDashboardImage = 15,
    DeleteDashboardImage = 16,
    ViewInspectionDataRequest = 17, // Pending Request
    ApproveInspectionDataRequest = 18,
    RejectInspectionDataRequest = 19,
    ViewMPointsDataRequest = 20,
    ApproveMPointsDataRequest = 21,
    RejectMPointsDataRequest = 22,
    ViewVDataDataRequest = 23,
    ApproveVDataDataRequest = 24,
    RejectVDataDataRequest = 25,
    ViewPipeline = 26,
    AddPipeline = 27,
    UpdatePipeline = 28,
    DeletePipeline = 29,
    ViewUWI = 30,
    UploadInspection = 31, 
    DownloadInspection = 32, 
    ViewInspection = 33, 
    ViewMetocean = 34,
    ViewMPoints = 35,
    UploadMPoints = 36,
    ViewVData = 37,
    UploadVData = 38,
    ViewGIS = 39,
    ViewSpan = 40,
    ViewSpanChart = 41,
    ViewPrediction = 42,
    AddPrediction = 43,
    ViewSupport = 44,
    AddSupportTicket = 45,
    UpdateSupportTicket = 46,
    ViewPendingRequest = 47,
}

export class Permission {
    id!: string;
    displayOrder!: number;
    parentId!: string;
    permissionCode!: number;
    permissionName!: string;
    child!: Permission[];
  }
  
export class RolePermissionResponse {
    roleId!: string;
    roleName!: string;
    permissionId!: string;
    permissionName!: string;
    permissionCode!: number;
    userId!: string;
}

export class ApiResponse {
    success!: boolean;
    message!: string;
    version!: string;
}

export class RolePermissionRequest {
    roleId!: string;
    permissionIds!: string [];
}

export class Users {
    createdBy!: string;
    createdDate!: string;
    email!: string;
    firstName!: string;
    id!: string;
    isDeleted!: boolean;
    lastName!: string;
    modifiedBy!: string;
    modifiedDate!: string;
    tenantId!: string;
    roleId!: string;
}

export class DataImportRequest {
    id!: string;
    filePath!: string;
    status!: string;
    approvedBy!: string;
    approvedDate!: string;
    requestType!: string;
    fullFilePath!: string;
    createdBy!: string;
    modifiedBy!: string;
    modifiedDate!: string;
    createdDate!: string;
}

export class ImportantDates {
    uuid!: string;
    pipelineid!: string;
    inspectiondate!: string;
    inspection!: string;
    inspectiontype!: string;
    upload_id!: string;
    isDeleted!: boolean;
    createdBy!: string;
    createdDate!: string;
    inspectionyear!: string;
    modifiedBy!: string;
    modifiedDate!: string;
}

export class InspectionTypeDropdown {
    id?: string;
    name?: string;
}

export class RoleListDropdown {
    id?: string;
    roleName?: string;
}

export class ListDropdown {
    id?: string;
    name?: string;
}

export class UserRoleData {
    roleId?: string;
    userId?: string;
}

export class RegionListDropdown {
    id?: string;
    regionName?: string;
}

export class ServiceListDropdown {
    id?: string;
    serviceName?: string;
}

export class PotfModel {
    token!: string;
    userId!: string;
    userEmail!: string;
    userTenant!: string;
    tenantConnString!: string;
    tenantDatabase!: string;
    tenantName!: string;
    tenantTitle!: string;
}

export class Regions {
    id!: string;
    regionName!: string;
    regionValue!: boolean;
    isDeleted!: boolean;
}

export class OpuListDropdown {
    id?: string;
    opuName?: string;
}

export class Opus {
    id!: string;
    opuName!: string;
    opuValue!: boolean;
    isDeleted!: boolean;
}

export class UserRoles {
    userId?: string;
    roleIds?: string[];
}

export class AccessRoles {
    userId?: string;
    opuIds?: string[];
    regionIds?: string[];
}

export class UserRoleResponse
    {
        userId? : string;
        userName? : string;
        roleId? : string;
        roleName? : string;
}

export class UserAccessResponse
    {
        userId? : string;
        opuId? : string;
        regionId? : string;
        opuName? : string;
        regionName? : string;
}

export class Roles {
    id!: string;
    roleName!: string;
    isSystemRole!: boolean;
    isDeleted!: boolean;
    roleCode!: string;
    createdBy!: string;
    createdDate!: string;
    modifiedBy!: string;
    modifiedDate!: string;
    tenantId!: string;
}

export class AddRoles {
    roleName!: string;
    isSystemRole!: boolean;
    isDeleted!: boolean;
    roleCode!: string;
    createdBy!: string;
    createdDate!: string;
    modifiedBy!: string;
    modifiedDate!: string;
    tenantId!: string;
    permissionIds!: string[];
    permissionCodes!: string;
}

export class Ticket {
    id!: string;
    ticketId!: string;
    ticketTitle!: string;
    senderEmailAddress!: string;
    ticketType!: string;
    ticketInquiry!: string;
    statusUpdate!: string;
    status!: string;
    isDeleted!: boolean;
    emailQueueId!: string;
    createdBy!: string;
    createdDate!: string;
    modifiedBy!: string;
    modifiedDate!: string;
}

export class SpanResults {
    datagroup!: string;
    r!: number;
    r2!: number;
    mae!: number;
    mape!: number;
    interval_year!: number;
    run_id!: number;
    experiment_id!: string;
    modified_date!: string;
}

export class SpanLengthResults {
    serialno!: number;
    actual!: number;
    predicted!: number;
    max_length!: number;
}

export class SpanHeightResults {
    serialno!: number;
    actual!: number;
    predicted!: number;
    max_length!: number;
}

export class Tenants {
    id!: string;
    apiIKEy!: boolean;
    tenantName!: string;
    connectionString!: string;
    isActive!: boolean;
    tenantId!: string;
}

export class Secrets {
    secretName!: string;
    encryptedValue!: string;
}

export class PermissionList {
    id!: string;
    permissionName!: string;
    parentId!: string;
    displayOrder!: number;
    roleId!: string;
    check!: boolean;
    permissionCode!: number;
}

export class OpuList {
    id?: string;
    opuName?: string;
}

export class FileUpload {
    fileName?: string;
    containerReference?: string;
    dirReference?: string;
    fileContent?: Int32Array[];
    formData?: FormData;
}

export class DashboardImages {
    fileName!: string;
    createdBy!: string;
    createdDate!: string;
    id!: string;
    isDeleted!: boolean;
}

export class PipelineBarChart {
    region!: string;
    totalPipeline!: number;
}

export class Pipelines {
    id!: string;
    createdBy!: string;
    createdDate!: string;
    modifiedBy!: string;
    modifiedDate!: string;
    isDeleted!: boolean;
    pipelineID!: string;
    pipelineName!: string;
    region!: string;
    services!: string;
    startLocation!: string;
    endLocation!: string;
    length!: number;
    diameter!: number;
    materialGrade!: string;
    commisioningYear!: number;
    commisioningYearDisplay!: string;
    tenantId!: string;
}

export class InspectionData {
    sno!: number;
    kp_start!: number;
    kp_end!: number;
    easting_s!: number;
    northing_s!: number;
    easting_e!: number;
    northing_e!: number;
    length!: number;
    height!: number;
    pipelineID!: string;
    inspection_type!: string;
    year!: string;
    insspectionID!: string;
}

export class MetoceanPointsData {
    srno!: number;
    longi!: number;
    lati!: number;
    easting!: number;
    northing!: number;
    pipeline!: string;
}

export class PredictionRequest {
    id!: number;
    pipeline!: string;
    modelType!: string;
    pipelineYear!: string;
    region?:string;
    pipelineType!: string;
    numberOfYears!: number;
    status!: number;
    remarks?: string;
    requestDate!: string;
    predictionDate!: string;
    createdBy!: string;
    createdDate!: string;
    modifiedBy!: string;
    modifiedDate!: string;
    emailQueueId!: string;
    tenantId!: string;
    tenantName!: string;
}

export class PredictionResult
{
    sno!: number;
    kp_start!: number;
    kp_end!: number;
    easting_s!: number;
    northing_s!: number;
    easting_e!: number;
    northing_e!: number;
    predicted!: number;
    max_allowable!: number;
    inspectionid!: string;
}
